var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83893 1.27857L6.00537 5.44501L10.1718 1.27857C10.5906 0.85978 11.2671 0.85978 11.6859 1.27857C12.1047 1.69736 12.1047 2.37387 11.6859 2.79267L6.75705 7.72152C6.33825 8.14032 5.66174 8.14032 5.24295 7.72152L0.314094 2.79267C-0.104698 2.37387 -0.104698 1.69736 0.314094 1.27857C0.732886 0.870518 1.42013 0.85978 1.83893 1.27857Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.73ca090bc458ed294d01db7ad27cb7a7.svg";
export { ForwardRef as ReactComponent };